import React, { useState, useEffect, useRef, useContext } from "react";
import styles from "./styles/AddBeneficiary.module.css";
import { UserData } from "../../../Context/DataContext";
import NewBeneficiary from "../Add Beneficiary/new_beneficiary";
import NewTrustee from "../Add Trustee/NewTrustee";
import { LanguageContext } from "../../../Context/changeLanguageProvider";

function AddTrustee({ alreadySelected, user_type, onSelect, openAssets }) {
  const [options, showOptions] = useState(false);
  const userData = UserData();
  const [openAdd, setOpenAdd] = useState(false);
  const wrapperRef = useRef(null);
  const [blink, setBlink] = useState(false);
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(
    websiteCurrentLang.content.User.AddAsset.AddBeneficiary
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.User.AddAsset.AddBeneficiary);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target) &&
        event.target.innerText !== "OK"
      ) {
        showOptions(false);
        setBlink(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  useEffect(() => {
    if (openAssets) {
      setBlink(true);
      showOptions(true);
    }
  }, [openAssets]);

  const beneficiariesAmount = UserData().UserData.beneficiaries.length;
  const selectedItems = userData.UserData[user_type].filter(
    (user) => !alreadySelected.includes(user.user_id)
  );
  selectedItems.sort((a, b) => {
    if (a.priority === b.priority) {
      return a.name.localeCompare(b.name);
    }
    return a.priority - b.priority;
  });
  return (
    <div
      onClick={() => showOptions(!options)}
      ref={wrapperRef}
      className={styles.main}
      style={
        user_type === "trustees"
          ? {
              position: "static",
            }
          : {}
      }
    >
      <div className={styles.add_asset}>
        <div className={styles.plus} />
      </div>
      {options ? (
        <>
          <div
            onClick={(e) => e.stopPropagation()}
            className={`${styles.options} ${blink ? styles.blink : ""}`}
            style={
              user_type === "trustees"
                ? {
                    maxHeight: "max-content",
                    left: 0,
                  }
                : { maxHeight: "max-content" }
            }
          >
            <div
              style={{ width: "100%", height: "20px", position: "relative" }}
            >
              <div
                onClick={() => showOptions(false)}
                className={styles.close}
              />
            </div>
            {selectedItems.map((individual) => {
              console.log(individual);
              let initials = "";
              let extension = "";
              individual.profile_avatar &&
                (extension = individual.profile_avatar[0]);
              if (extension === "/") extension = ".jpg";
              else if (extension === "i") extension = ".png";

              individual.name
                .split(" ")
                .map((n) => (initials = initials + n[0]));
              return (
                <div
                  style={{
                    whiteSpace: "wrap",
                  }}
                  key={individual.user_id}
                  onClick={() => onSelect(individual)}
                  className={styles.option_cell}
                >
                  {individual.profile_avatar ? (
                    <img
                      className={styles.beneficiary_trustee}
                      alt="avatar"
                      src={`data:image/${extension};base64,${individual.profile_avatar}`}
                    ></img>
                  ) : (
                    <div
                      className={`${styles.beneficiary_trustee} ${
                        individual.priority === "1"
                          ? styles.priority1
                          : individual.priority === "2"
                          ? styles.priority2
                          : ""
                      }`}
                    >
                      <span
                        style={{
                          overflow: "hidden",
                          textWrap: "nowrap",
                        }}
                      >
                        {initials.length > 4 ? (
                          <>{initials.slice(0, 4)}...</>
                        ) : (
                          initials
                        )}
                        {/* {initials} */}
                      </span>
                    </div>
                  )}
                  {/* {individual.name +
                    ("last_name" in individual
                      ? " " + individual.last_name
                      : "")} */}
                  <span
                    style={{
                      width: "70%",
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      lineClamp: 2,
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      display: "-webkit-box",
                      wordBreak: "break-all",
                    }}
                  >
                    {/* {individual.name.length >= 42
                      ? individual.name.slice(0, 42) + "..."
                      : individual.name} */}
                    {individual.name}
                  </span>
                </div>
              );
            })}

            {user_type === "trustees" && (
              <div
                className={`${styles.option_cell} ${styles.option_cell_add}`}
                onClick={() => {
                  setOpenAdd(true);
                }}
              >
                <div className={styles.add_asset_small}></div>
                {dublicatedcontent.dublicatedText73}
              </div>
            )}

            {user_type === "beneficiaries" && beneficiariesAmount < 12 && (
              <div
                className={`${styles.option_cell} ${styles.option_cell_add}`}
                onClick={() => {
                  setOpenAdd(true);
                }}
              >
                <div className={styles.add_asset_small}></div>
                {content.addBeneficiaryText2}
              </div>
            )}

            {openAdd ? (
              user_type === "beneficiaries" ? (
                <NewBeneficiary onClose={() => setOpenAdd(false)} />
              ) : (
                <NewTrustee onClose={() => setOpenAdd(false)} />
              )
            ) : null}
          </div>
        </>
      ) : null}
    </div>
  );
}

export default AddTrustee;
